/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentStatusEnum as ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum } from '../../models/Models/Customer/Enums/customer-online-payment-status-enum';

export interface V3CustomersMeOnlinePaymentsIdStatusGet$Json$Params {
  id: string;
}

export function v3CustomersMeOnlinePaymentsIdStatusGet$Json(http: HttpClient, rootUrl: string, params: V3CustomersMeOnlinePaymentsIdStatusGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeOnlinePaymentsIdStatusGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerEnumsCustomerOnlinePaymentStatusEnum>;
    })
  );
}

v3CustomersMeOnlinePaymentsIdStatusGet$Json.PATH = '/v3/customers/me/online-payments/{id}/status';
